type Listener = () => void;

const listeners = new Set<Listener>();

/**
 * Панель поиска живёт в навбаре, а открыть её нужно и со страницы результатов
 * («Изменить запрос»), и по Cmd/Ctrl + K. Общего родителя у них нет, тянуть ради
 * этого состояние в Redux избыточно — хватает подписки на модуле.
 */
export const openGlobalSearch = () => listeners.forEach((listener) => listener());

export const subscribeGlobalSearchOpen = (listener: Listener): (() => void) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};
